<template>
  <basic-container>
    <div class="journalList-container">
      <div class="banner_w3lspvt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">{{ $t('journalLi.title') }}</li>
        </ol>
      </div>

      <div class="journal_content">
        <div class="article_container_bottom">
          <div class="articleS_top">
            <!-- <div class="title_header">论&nbsp;文</div> -->
            <!-- 普通检索 -->
            <div class="title_bottom_first" v-if="!isAdvancedSearch">
              <el-input v-model="searchReferenceQuery.esQueryDtoList[0].data" clearable :placeholder="getAlertMessage(searchReferenceQuery.esQueryDtoList[0])
                " class="input-with-select">
                <el-select v-model="searchReferenceQuery.esQueryDtoList[0].selectOptions"
                  :placeholder="$t('journalLi.choice')" slot="prepend">
                  <el-option v-for="item in selectLiteratureOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="clickReferenceSearch">{{ $t('journalLi.search')
                }}</el-button>
              </el-input>
              <el-link @click="switchMode">{{ $t('journalLi.advancedSearch') }}&nbsp;<i class="el-icon-d-arrow-right"></i>
              </el-link>
            </div>
            <!-- 高级检索 -->
            <div class="title_bottom" v-if="isAdvancedSearch">
              <div class="literature" v-for="(select, index) in searchReferenceQuery.esQueryDtoList" :key="index"
                style="width: 100%">
                <div class="literatureSelect">
                  <div class="reduce" v-if="index !== 0">
                    <i style="margin-right: inherit" class="el-icon-remove-outline"
                      @click="reduceLiteratureRow(index)"></i>
                  </div>
                  <div class="literatureSelectLeft" v-if="index !== 0" style="width: 13%; display: inline-block">
                    <el-select v-model="select.type" :placeholder="$t('journalLi.choice')">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="literatureSelectLeft" style="width: 14%; display: inline-block">
                    <el-select v-model="select.selectOptions" :placeholder="$t('journalLi.choice')">
                      <el-option v-for="item in selectLiteratureOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="literatureSelectRight" style="width: 85%; display: inline-block">
                    <el-input v-model="select.data" clearable :placeholder="getAlertMessage(select)"></el-input>
                  </div>
                </div>
              </div>
              <el-button @click="addLiteratureRow">+AddRow</el-button>

              <div class="btnJournalLi">
                <el-link @click="switchMode"><i class="el-icon-d-arrow-left"></i>&nbsp;{{ $t('journalLi.generalSearch') }}
                </el-link>
                <el-button @click="clickReferenceSearch" icon="el-icon-search">{{ $t('journalLi.search') }}</el-button>
                <el-button @click="reset" icon="el-icon-circle-plus-outline">{{ $t('journalLi.reset') }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 双一流搜索块 -->

        <div class="journal_middle">
          <div v-if="searchReferenceQuery.aggEsQueryDtoList.length > 0" style="margin: 30px 0 0 0">
            <div style="display: flex">
              <div v-for="(
                  content, index
                ) in searchReferenceQuery.aggEsQueryDtoList" :key="index" :style="{
                  marginBottom:
                    index < searchReferenceQuery.aggEsQueryDtoList.length - 1
                      ? '20px'
                      : '0',
                }">
                <span style="
                    margin: 0px 5px 8px 0px;
                    background-color: #4f49491f;
                    border-radius: 10px;
                    padding: 5px;
                  ">
                  {{ content.excludeOrApplyFlag == "0" ? "排除 " : "应用 " }}
                  <span v-for="(item, indexChild) in content.listData" :key="indexChild">
                    {{ indexChild != 0 ? " and " : "" }}{{ item }}
                  </span>
                  <i class="el-icon-close" style="cursor: pointer" @click="removeContent(index)"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="articleList_container_bottom">
            <div class="card_left" v-loading="leftLoading">
              <!-- <p>综合筛选</p> -->

              <!-- 年份 -->
              <div class="block">
                <div class="title">
                  <span class="lines"></span>
                  <span>{{ $t('journalLi.year') }}</span>
                </div>
                <div class="category">
                  <p class="allTotalValue">
                    <span><span class="block"></span>{{ $t('journalLi.all') }}</span>
                  </p>
                  <el-checkbox-group v-model="selectedYearList" @change="handleYearChecked">
                    <div v-for="(list, index) in leftJournalList.yearAgg" :key="index">
                      <el-checkbox :label="list.name" :key="index" class="category_card">
                        <span>{{ list.name }}</span>
                        <span>({{ list.value }})</span>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <div class="three_btn" v-if="leftJournalList.yearAgg && leftJournalList.yearAgg.length > 1">
                  <span @click="cancelSelectedItems('year', selectedYearList)">{{ $t('journalLi.cancel') }}</span>
                  <span @click="excludeCheckedList('year', selectedYearList)">{{ $t('journalLi.exclude') }}</span>
                  <span @click="applyCheckedList('year', selectedYearList)">{{ $t('journalLi.apply') }}</span>
                </div>
              </div>
              <!-- 类别 -->
              <div class="block">
                <div class="title">
                  <span class="lines"></span>
                  <span>{{ $t('journalLi.type') }}</span>
                </div>
                <div class="category">
                  <p class="allTotalValue">
                    <span><span class="block"></span>{{ $t('journalLi.all') }}</span>
                  </p>
                  <el-checkbox-group v-model="selectedTypeList" @change="handleTypeChecked">
                    <div v-for="(list, index) in leftJournalList.typeAgg" :key="index">
                      <el-checkbox :label="list.name" :key="index" class="category_card">
                        <span>{{ list.name }}</span>
                        <span>({{ list.value }})</span>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <div class="three_btn" v-if="leftJournalList.typeAgg && leftJournalList.typeAgg.length > 1">
                  <span @click="cancelSelectedItems('type', selectedTypeList)">{{ $t('journalLi.cancel') }}</span>
                  <span @click="excludeCheckedList('type', selectedTypeList)">{{ $t('journalLi.exclude') }}</span>
                  <span @click="applyCheckedList('type', selectedTypeList)">{{ $t('journalLi.apply') }}</span>
                </div>
              </div>
            </div>
            <!-- 右边数据 -->
            <div class="card_right" v-loading="rightLoading">
              <div class="box_bottom">
                <div class="article_top">
                  <div class="article_top_left">
                    <div v-if="showSearchResults">
                      {{ $t('journalLi.searchResults') }}<span style="color: #b40009; margin: 0 3px">{{ total }}</span>{{
                        $t('journalLi.item') }}
                    </div>
                  </div>
                  <div class="article_top_right">
                    <div class="right_block">
                      <!-- <span class="caret-wrapper">
											<i class="el-icon-caret-top" :class="{active: sortOrder === 'ascs'}"
												@click="sortChange('ascs', 'year')"></i>
											<i class="el-icon-caret-bottom" :class="{ active: sortOrder === 'descs' }"
												@click="sortChange('descs', 'year')"></i>
										</span> -->
                      <span>{{ $t('journalLi.journalStatus') }}</span>
                      <span>{{ $t('journalLi.searchType') }}</span>
                      <span class="year-ele">{{ $t('journalLi.year') }}</span>
                      <span>{{ $t('journalLi.month') }}</span>
                    </div>
                  </div>
                </div>
                <div class="article_bottom" v-for="(item, index) in journalList" :key="index">
                  <div style="
                      display: flex;
                      flex-direction: column;
                      border-bottom: 1px solid #eeeeee;
                    ">
                    <div class="article_card">
                      <div class="article_card-top">
                        <div class="article_card_left">
                          <div>
                            <div class="serial">
                              {{
                                index +
                                1 +
                                (searchReferenceQuery.current - 1) * 10
                              }}.
                            </div>
                            <div>
                              <p class="articleTitle" @click="tipArticleDetail(item)">
                                {{ item.journalName }}
                              </p>
                              <p class="rightContentF">
                                <span class="fu">ISSN:</span>{{ item.issn }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="article_card_right">
                          <span style="width: 18%">{{
                            item.journalStatus
                          }}</span>
                          <span style="width: 8%">{{ item.type }}</span>
                          <span style="width: 9%">{{ item.year }}</span>
                          <span style="width: 5%">{{ item.month }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pagination">
                  <el-pagination ref="pagination" background layout="prev, pager, next,slot"
                    :page-size="searchReferenceQuery.pageSize" @current-change="handleCurrentChange" :pager-count="9"
                    :first-text="$t('paginationText.firstText')" :last-text="$t('paginationText.lastText')"
                    :prev-text="$t('paginationText.prevText')" :next-text="$t('paginationText.nextText')" :total="total"
                    hide-on-single-page>
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getJournalData } from '@/api/journal/journalList'

export default {
  name: "index",
  data() {
    return {
      isAdvancedSearch: false, //高级搜索
      showSearchResults: false, //显示搜索结果
      //文献的选择项
      selectLiteratureOptions: [
        {
          value: "journalName",
          label: this.$t("journalLi.literature.journalName"),
        },
        {
          value: "issn",
          label: this.$t("journalLi.literature.issn"),
        },
        {
          value: "year",
          label: this.$t("journalLi.literature.year"),
        },
      ],
      alertMessages: "",
      //类别选项
      type: [
        {
          value: 0,
          label: "And",
        },
        {
          value: 1,
          label: "Or",
        },
        {
          value: 2,
          label: "Not",
        },
      ],
      total: 33,
      //文献查询条件
      searchReferenceQuery: {
        pageSize: 10,
        current: 1,
        esQueryDtoList: [
          {
            selectOptions: "journalName",
            data: "",
            type: "0",
          },
        ],
        aggEsQueryDtoList: [],
      },
      selectedYearList: [], //被选中的年份
      selectedTypeList: [], //被选中的类型
      journalList: [], //期刊
      leftJournalList: [], //左侧期刊

      sortOrder: "", // 初始排序顺序为空
      queryOrder: {},
      leftLoading: false,
      rightLoading: false,

      snapshotData: {}, // 用于存储数据快照
    };
  },
  computed: {},

  created() { },

  methods: {
    getAllData() {
      this.fetchData(
        "/jdc-data/jdcjournal/getJdcPageJournal",
        this.getRightDataSuccess,
        this.errorHandler
      );
      this.fetchData(
        "/jdc-data/jdcjournal/getJdcMetricJournal",
        this.getLeftDataSuccess,
        this.errorHandler
      );
    },
    //普通检索和高级检索切换
    switchMode() {
      this.isAdvancedSearch = !this.isAdvancedSearch;
      this.reset();
    },

    //匹配placeHolder
    getAlertMessage(select) {
      const fieldPlaceholders = {
        issn: this.$t("journalLi.literatureRules.issn"),
        year: this.$t("journalLi.literatureRules.year"),
        journalName: this.$t("journalLi.literatureRules.journalName"),
      };

      // 根据 select.selectOptions 返回相应的 placeholder
      return fieldPlaceholders[select.selectOptions] || this.$t("journalLi.defaultPlaceholder");
    },
    //添加文献行
    addLiteratureRow() {
      this.alertMessages = "";
      if (this.searchReferenceQuery.esQueryDtoList.length < 5) {
        let ob = {
          selectOptions: "", // 初始化 selectOptions
          data: "",
          type: "", // 初始化 type
        };
        this.searchReferenceQuery.esQueryDtoList.push(ob);
      } else {
        this.$message({
          message: "您已超出检索条件限制，请确保将条件限制为5条内！",
          type: "warning",
        });
      }
    },
    //移除文献行
    reduceLiteratureRow(index) {
      this.searchReferenceQuery.esQueryDtoList.splice(index, 1);
    },
    //重置
    reset() {
      this.searchReferenceQuery.esQueryDtoList = [
        {
          selectOptions: "journalName",
          data: "",
          type: "0",
        },
      ];
    },
    // 点击搜索
    clickReferenceSearch() {
      this.searchReferenceQuery.current = 1
      if (this.searchReferenceQuery.esQueryDtoList[0].data == 0) {
        this.journalList = this.snapshotData.journalList;

        this.leftJournalList = this.snapshotData.leftJournalList;
        this.total = this.snapshotData.total;
        this.showSearchResults = true;
        return;
      }
      this.showSearchResults = true;
      this.getAllData();
    },

    // 发送 AJAX 请求
    fetchData(url, successCallback, errorCallback = this.errorHandler) {
      if (url == "/jdc-data/jdcjournal/getJdcPageJournal") {
        this.rightLoading = true;
      } else if ("/jdc-data/jdcjournal/getJdcMetricJournal") {
        this.leftLoading = true;
      }
      getJournalData(url, this.searchReferenceQuery).then((res) => {
        if (res.code == 200) {
          successCallback(res)
        } else {
          errorCallback(res.message);
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: "请检查搜索条件是否正确！",
        });

      });
    },

    // 左边数据成功回调
    getLeftDataSuccess(response) {
      this.leftJournalList = response.data;
      this.leftJournalList.yearAgg = this.leftJournalList.yearAgg.sort((a, b) =>
        b.name.localeCompare(a.name)
      );

      this.leftLoading = false;

      if (!this.snapshotData.leftJournalList) {
        this.snapshotData.leftJournalList = Object.assign(
          {},
          this.leftJournalList
        );
      }
    },

    // 右边数据成功回调
    getRightDataSuccess(response) {
      this.journalList = response.data.records;
      this.total = response.data.total;
      this.rightLoading = false;

      // 保存数据快照
      if (!this.snapshotData.journalList || !this.snapshotData.total) {
        this.snapshotData.journalList = [...this.journalList];
        this.snapshotData.total = this.total;
      }
    },

    // 错误处理
    errorHandler(xhr, status, error) {
      console.error("Error:", error);
      this.$message({
        message: this.$t('messagePrompt.fail'),
        type: "error",
      });
    },

    //获取勾选得年份
    handleYearChecked() { },
    // 获取勾选得类型
    handleTypeChecked() { },
    // 查找条件索引
    findConditionIndex(type, flag, list) {
      return this.searchReferenceQuery.aggEsQueryDtoList.findIndex(
        (item) =>
          item.selectType === type &&
          item.excludeOrApplyFlag === flag &&
          JSON.stringify(item.listData) === JSON.stringify(list)
      );
    },

    // 通用处理选中项的方法
    handleCheckedList(type, list, flag) {
      if (list.length === 0) {
        this.$message({
          message: this.$t('messagePrompt.noSelect'),
          type: "warning",
        });
        return;
      }

      const ob = {
        selectType: type,
        listData: list,
        excludeOrApplyFlag: flag,
      };

      // 查找是否已存在相同的条件
      const existingConditionIndex =
        this.searchReferenceQuery.aggEsQueryDtoList.findIndex(
          (item) =>
            item.selectType === ob.selectType &&
            item.excludeOrApplyFlag === ob.excludeOrApplyFlag
        );

      if (existingConditionIndex !== -1) {
        // 如果已存在相同类型的条件，则更新该条件的列表数据
        this.searchReferenceQuery.aggEsQueryDtoList[
          existingConditionIndex
        ].listData = list;
      } else {
        // 如果不存在，则添加新的条件
        this.searchReferenceQuery.aggEsQueryDtoList.push(ob);
      }
      this.getAllData();
    },

    // 排除选中项
    excludeCheckedList(type, list) {
      // 检查是否存在相同类型且应用标记为 '1' 的条件
      const applyConditionIndex = this.findConditionIndex(type, "1", list);

      if (applyConditionIndex !== -1) {
        this.$message({
          message: this.$t('journalLi.applySelect'),
          type: "warning",
        });
        return;
      }

      // 检查是否已经有排除的条件
      const excludeConditionIndex = this.findConditionIndex(type, "0", list);

      if (excludeConditionIndex === -1) {
        // 如果没有找到相同的排除条件，则调用 handleCheckedList
        this.handleCheckedList(type, list, "0");
      }
    },

    // 应用选中项
    applyCheckedList(type, list) {
      // 检查是否存在相同类型且排除标记为 '0' 的条件
      const excludeConditionIndex = this.findConditionIndex(type, "0", list);

      if (excludeConditionIndex !== -1) {
        this.$message({
          message: this.$t('journalLi.excludeSelect'),
          type: "warning",
        });
        return;
      }

      // 检查是否已经有应用的条件
      const applyConditionIndex = this.findConditionIndex(type, "1", list);

      if (applyConditionIndex === -1) {
        // 如果没有找到相同的应用条件，则调用 handleCheckedList
        this.handleCheckedList(type, list, "1");
      } else {
        // 清空之前的选中项并重新渲染结果
        this.searchReferenceQuery.aggEsQueryDtoList = [];

        // 重新添加应用条件
        this.handleCheckedList(type, list, "1");
      }
    },
    //取消选中
    cancelSelectedItems(type, item) {
      if (item == "") {
        this.$message({
          message: this.$t('journalLi.cancelSelect'),
          type: "warning",
        });
      } else if (type == "year") {
        this.selectedYearList = [];
      } else if (type == "type") {
        this.selectedTypeList = [];
      }
    },

    //删除选项
    removeContent(index) {
      this.searchReferenceQuery.aggEsQueryDtoList.splice(index, 1);
      this.getAllData();
    },
    //重置每一项
    restItem() {
      this.searchReferenceQuery.current = 1;
      this.getAllData();
    },
    //排序

    handleCurrentChange(val) {
      this.searchReferenceQuery.current = val;
      this.fetchData(
        "/jdc-data/jdcjournal/getJdcPageJournal",
        this.getRightDataSuccess,
        this.errorHandler
      );
    },
    //跳详情页
    tipArticleDetail(item) {
      this.$router.push({
        path: "/Journal-Details",
        query: {
          issn: item.issn,
          type: item.type
        }
      })
    },
  },
  created() { },
  mounted() {
    this.getAllData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/originCss/journalList.css";

::v-deep .el-pagination.is-background .el-pager li{
    margin: 0 3px;
}

::v-deep .el-pagination.is-background .btn-next:hover {
  background-color: #409EFF;
  color: #fff;
}

::v-deep .el-pagination.is-background .btn-prev:hover {
  background-color: #409EFF;
  color: #fff;
}

::v-deep .el-pagination {
  white-space: normal;
  padding: 2px 0;
 

}


</style>
